import { render, staticRenderFns } from "./bknDnyHeho.vue?vue&type=template&id=32c0bfa5"
import script from "./bknDnyHeho.vue?vue&type=script&lang=js"
export * from "./bknDnyHeho.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports